import type { Organization, WithContext } from 'schema-dts'

export const ORGANIZATION_JSON_LD: WithContext<Organization> = {
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: 'Cocoon Space',
	logo: 'https://www.cocoon-space.com/images/v2/logo.png',
	url: 'https://www.cocoon-space.com',
}
